import * as React from 'react';

import { Block } from 'emotion-jsxstyle';

export const Card: React.SFC<any> = ({ responsive = true, ...otherProps }) => {
  return <Block className={responsive ? 'card card-responsive' : 'card'} {...otherProps} />;
};



// WEBPACK FOOTER //
// ./src/common/components/Card.tsx